import React, { /* ChangeEvent ,*/ useEffect, useState } from "react";
// import { Form } from "react-bootstrap";
import styles from "./book.module.scss";
import BusLayout from "../../components/BusLayout";
import {
  IBusLayout,
  SEAT_LAYOUT,
  SEAT_STYLE,
  SeatAvailability,
} from "../../common/types";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { API_CONSTANTS } from "../../common/constants/api";
import { SESSION_KEYS } from "../../common/constants/sessionKeys";
import { Button, Heading } from "@radix-ui/themes";

const BusBook = () => {
  const [searchParams] = useSearchParams();
  const [seats, setSeats] = useState<number>(0);
  const [seatsPrice, setSeatsPrice] = useState<number>(0);
  const [sleepers, setSleepers] = useState<number>(0);
  const [sleepersPrice, setSleepersPrice] = useState<number>(0);
  const [totalPrice, setTotalPrice] = useState<number>(0);
  // const [boardingPoints, setBoardingPoints] = useState<string[]>([]);
  // const [droppingPoints, setDroppingPoints] = useState<string[]>([]);
  // const [boardingPoint, setBoardingPoint] = useState<string>();
  // const [droppingPoint, setDroppingPoint] = useState<string>();
  const [fromLocation, setFromLocation] = useState<string | null>();
  const [toLocation, setToLocation] = useState<string | null>();
  const [busName, setBusName] = useState<string | null>();
  const [journeyDate, setJourneyDate] = useState<string | undefined | null>();
  const [busRouteMappingId, setBusRouteMappingId] = useState<
    string | undefined | null
  >();
  const [isAc, setIsAc] = useState<boolean>(false);
  const [seatLayout, setSeatLayout] = useState<SEAT_LAYOUT>(
    SEAT_LAYOUT.SINGLE_LAYER_SEATING_3X2
  );
  const [seatStyle, setSeatStyle] = useState<SEAT_STYLE>(SEAT_STYLE.SEATING);
  const [seatingSeats, setSeatingSeats] = useState<SeatAvailability[]>([]);
  const [sleepingSeats, setSleepingSeats] = useState<SeatAvailability[]>([]);
  const [isSingleFirstSeat, setIsSingleFirstSeat] = useState<boolean>(false);
  const [busId, setBusId] = useState<string | undefined | null>();

  /*   const handleBoardingPointSelect = (evt: ChangeEvent<HTMLSelectElement>) => {
    setBoardingPoint(evt.target.value);
  };

  const handleDroppingPointSelect = (evt: ChangeEvent<HTMLSelectElement>) => {
    setDroppingPoint(evt.target.value);
  }; */

  const toggleSeatHandler = (seats: SeatAvailability[]) => {
    const _tmp: SeatAvailability[] = seats.filter((seat: SeatAvailability) => {
      return seat.isSelected && seat.isAvailable;
    });
    setSeats(_tmp.length);
    const seatsPrice = _tmp.reduce(
      (prevValue: number, currentSeat: SeatAvailability) =>
        prevValue + currentSeat.price,
      0
    );
    setSeatsPrice(seatsPrice);
    setTotalPrice(seatsPrice + sleepersPrice);
    sessionStorage.setItem(SESSION_KEYS.SEATING_SEATS, JSON.stringify(_tmp));
    sessionStorage.setItem(
      SESSION_KEYS.TOTAL_PRICE,
      JSON.stringify(seatsPrice + sleepersPrice)
    );
  };

  const toggleSleepingHandler = (seats: SeatAvailability[]) => {
    const _tmp: SeatAvailability[] = seats.filter((seat: SeatAvailability) => {
      return seat.isSelected && seat.isAvailable;
    });
    setSleepers(_tmp.length);
    const sleeperPrice = _tmp.reduce(
      (prevValue: number, currentSeat: SeatAvailability) =>
        prevValue + currentSeat.price,
      0
    );
    setSleepersPrice(sleeperPrice);
    setTotalPrice(seatsPrice + sleepersPrice);
    sessionStorage.setItem(SESSION_KEYS.SLEEPING_SEATS, JSON.stringify(_tmp));
    sessionStorage.setItem(
      SESSION_KEYS.TOTAL_PRICE,
      JSON.stringify(seatsPrice + sleeperPrice)
    );
  };

  useEffect(() => {
    /* setBoardingPoints(["Sector 2", "Cheend", "Panposh", "Jalda"]);
    setBoardingPoint("Sector 2");
    setDroppingPoints(["Master Canteen", "Jaydev Bihar", "Barmunda"]);
    setDroppingPoint("Barmunda"); */
    setIsAc(false);
    setSeatLayout(SEAT_LAYOUT.SINGLE_LAYER_SEATING_3X2);
    setSeatStyle(SEAT_STYLE.SEATING);
    setSeatingSeats([]);
    setSleepingSeats([]);
    setIsSingleFirstSeat(false);
  }, []);

  useEffect(() => {
    setBusId(searchParams.get("busId"));
    setJourneyDate(searchParams.get("date"));
    setBusRouteMappingId(searchParams.get("busRouteMappingId"));
    setToLocation(searchParams.get("to"));
    setFromLocation(searchParams.get("from"));
    setBusName(searchParams.get("busName"));
  }, [searchParams]);

  /* useEffect(() => {
    if (fromLocation && toLocation) {
      sessionStorage.setItem(SESSION_KEYS.FROM_LOCATION, fromLocation);
      sessionStorage.setItem(SESSION_KEYS.TO_LOCATION, toLocation);
    }
  }, [fromLocation, toLocation]); */

  useEffect(() => {
    if (busId && busRouteMappingId && journeyDate) {
      sessionStorage.removeItem(SESSION_KEYS.SLEEPING_SEATS);
      sessionStorage.removeItem(SESSION_KEYS.SEATING_SEATS);
      axios
        .post(`${API_CONSTANTS.BUS_LAYOUT}`, {
          busRouteMappingId: busRouteMappingId,
          busId: busId,
          onDate: journeyDate,
          fromStop: sessionStorage.getItem(SESSION_KEYS.FROM_LOCATION_CODE),
          toStop: sessionStorage.getItem(SESSION_KEYS.TO_LOCATION_CODE),
        })
        .then((res) => {
          const _busLayout: IBusLayout = res.data;
          console.log("_busLayout", _busLayout);
          //_busLayout.seatingSeats[0].isBooked = true;
          //_busLayout.seatingSeats[10].isBooked = true;
          setIsAc(_busLayout.isAc);
          setSeatingSeats(_busLayout.seatingSeats);
          setSleepingSeats(_busLayout.sleepingSeats);
          setIsSingleFirstSeat(_busLayout.isSingleFirstSeats);
          setSeatLayout(_busLayout.seatLayout);
          setSeatStyle(_busLayout.seatStyle);
        });
    }
  }, [busId, busRouteMappingId, journeyDate]);

  function onCheckoutClickHandler(
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ): void {
    event.preventDefault();
    if (busId && journeyDate && busRouteMappingId) {
      window.location.href = `/checkout?busId=${busId}&date=${journeyDate}&busRouteMappingId=${busRouteMappingId}`;
    }
  }
  return (
    <main className="container pageContainer">
      <div className="row">
        <div className="col-12 mt-2 mb-2">
          <Heading
            as="h1"
            color="blue"
            align="center"
            className={styles.welcomeHeading}
          >
            Welcome Traveller
          </Heading>
          <Heading as="h2" align="center" className="mb-2">
            Please select seats to checkout
          </Heading>
        </div>
        <div className="col-12 mb-2">
          <Heading as="h3">Bus Details</Heading>
          <p className="mb-2">
            <strong>From:</strong> {fromLocation}
            <span className="mx-2" />
            <strong>To:</strong> {toLocation}
            <span className="mx-2" />
            <strong>Travel Date:</strong> {journeyDate}
            <span className="mx-2" />
            <strong>Bus Name:</strong> {busName}
            <span className="mx-2" />
            <strong>Seating Type:</strong> {seatLayout
              .toLowerCase()
              .split("_")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ")}
            <span className="mx-2" />
            <strong>Bus Type:</strong> {isAc ? "AC" : "Non AC"  }
          </p>
        </div>
        {/*  <div className="col-6 my-5">
          <Form.Group className="mb-3">
            <Form.Label>Boarding Point</Form.Label>
            <Form.Select className="w-50" onChange={handleBoardingPointSelect}>
              {boardingPoints.map((point: string, index: number) => {
                return (
                  <option key={index} value={point}>
                    {point}
                  </option>
                );
              })}
            </Form.Select>
          </Form.Group> 
        </div> */}
        {/* <div className="col-6 my-5">
          <Form.Group className="mb-3">
            <Form.Label>Dropping Point</Form.Label>
            <Form.Select className="w-50" onChange={handleDroppingPointSelect}>
              {droppingPoints.map((point: string, index: number) => {
                return (
                  <option key={index} value={point}>
                    {point}
                  </option>
                );
              })}
            </Form.Select>
          </Form.Group> 
        </div>*/}
        <div className="col-6 col-md-6 col-lg-3 my-3">
          <article
            className={`d-flex align-items-start flex-column ${styles.statusBox}`}
          >
            <div
              className={`bg-white border border-2 border-secondary ${styles.rect}`}
            ></div>
            <label>Available</label>
          </article>
        </div>
        <div className="col-6 col-md-6 col-lg-3 my-3">
          <article
            className={`d-flex align-items-start flex-column ${styles.statusBox}`}
          >
            <div
              className={`bg-danger border border-light-subtle ${styles.rect}`}
            ></div>
            <label>Booked</label>
          </article>
        </div>
        <div className="col-6 col-md-6 col-lg-3 my-3">
          <article
            className={`d-flex align-items-start flex-column ${styles.statusBox}`}
          >
            <div
              className={`border border-light-subtle ${styles.rect} ${styles.notAvailable}`}
            ></div>
            <label>Not Available</label>
          </article>
        </div>
        <div className="col-6 col-md-6 col-lg-3 my-3">
          <article
            className={`d-flex align-items-start flex-column ${styles.statusBox}`}
          >
            <div
              className={`bg-success border border-light-subtle ${styles.rect}`}
            ></div>
            <label>Selected</label>
          </article>
        </div>
        <div className="col-12 my-3">
          <h4>Seat Layout</h4>
        </div>
        <div className="col-12 my-1">
          <section>
            <BusLayout
              isAc={isAc}
              seatLayout={seatLayout}
              seatStyle={seatStyle}
              seatingSeats={seatingSeats}
              sleepingSeats={sleepingSeats}
              isSingleFirstSeats={isSingleFirstSeat}
              onToggleSeats={toggleSeatHandler}
              onToggleSleepers={toggleSleepingHandler}
            />
          </section>
        </div>
        <div className="col-12 my-1">
          <p>
            Seats: {seats} , Price: Rs {seatsPrice}/-
          </p>
          <p>
            Sleepers: {sleepers} , Price: Rs {sleepersPrice}/-
          </p>
          <p>Total Price: Rs {totalPrice}/-</p>
        </div>
        <div className="col-12 my-3">
          {/* <Link
            to={`/checkout?busId=${busId}&date=${journeyDate}&busRouteMappingId=${busRouteMappingId}`}
          >
            Checkout
          </Link> */}
          {/**
           * Add onClick handler to Button to navigate to checkout page
           * with busId, journeyDate and busRouteMappingId as query params
           */}
          <Button onClick={onCheckoutClickHandler}>Checkout</Button>
        </div>
      </div>
    </main>
  );
};

export default BusBook;
